<template>
  <div>
    <div class="row">
      <div class="col-xl-9 m-b-10">
        <b-card no-body>
          <b-table
            id="itemTable"
            striped
            sort-icon-left
            show-empty
            empty-text="There are no matching items to show"
            :items="this.itemsInType()"
            :per-page="perPage"
            :current-page="currentPage"
            :fields="fields"
          >
            <template v-slot:head(selected)>
              <b-form-checkbox v-model="itemsCheck" @change="checkAll"
                >Select all</b-form-checkbox
              >
            </template>
            <template v-slot:cell(selected)="{ item }">
              <b-form-checkbox
                size="lg"
                :value="item"
                v-model="selectedItems"
                @change="itemCheck"
              />
            </template>
            <template v-slot:cell(image)="{ item }">
              <img :src="getImage(item.image)" width="65px" />
            </template>
            <template v-slot:cell(name)="{ item }">
              {{ item.name }}
            </template>
            <template v-slot:cell(stage)="{ item }">
              {{ item.stage ? getStage(item.stage).name : '-' }}
            </template>
            <template v-slot:cell(storyboard)="{ item }">
              {{ getStoryboard(item) ? getStoryboard(item).name : '-' }}
            </template>
            <template v-slot:cell(stages)="{ item }">
              {{ item.stages }}
            </template>
            <template v-slot:cell(steps)="{ item }">
              {{ item.stepCount ? item.stepCount : item.steps }}
            </template>
            <template v-slot:cell(inUse)="{ item }">
              {{ checkUsage(item) ? 'Active' : 'Inactive' }}
            </template>
            <template v-slot:cell(actions)="{ item }">
              <url-button
                label="View details"
                :url="viewRoute(item)"
                class="btn-yellow"
              />
              <url-button
                v-if="planTitle && planRoute(item)"
                :label="planTitle()"
                :url="planRoute(item)"
                class="btn-gray"
              />
            </template>
          </b-table>
        </b-card>
      </div>
      <div class="col-xl-3">
        <div>
          <b-card no-body class="p-0">
            <div role="tablist">
              <b-card no-body class="p-0">
                <b-card-header header-tag="header" class="p-0" role="tab">
                  <b-button block v-b-toggle.tab1 variant="light"
                    >Filters</b-button
                  >
                </b-card-header>
                <b-collapse id="tab1" visible role="tabpanel">
                  <b-card-body>
                    <label class="width-full">
                      <b>Search:</b>
                      <input
                        v-model="search"
                        placeholder="Search item"
                        type="search"
                        class="form-control"
                      />
                    </label>
                    <label
                      class="width-full"
                      v-if="
                        $route.params.level == 'stages' ||
                        $route.params.level == 'steps'
                      "
                    >
                      <b>Storyboard:</b>
                      <select
                        v-model="storyboardFilter"
                        class="form-control"
                        @change="stageFilter = 'all'"
                      >
                        <option value="all" selected>All</option>
                        <option
                          v-for="sb in storyboards"
                          :key="sb.id"
                          :value="sb.id"
                        >
                          {{ sb.name }}
                        </option>
                      </select>
                    </label>
                    <label
                      class="width-full"
                      v-if="$route.params.level == 'steps'"
                    >
                      <b>Stage:</b>
                      <select v-model="stageFilter" class="form-control">
                        <option value="all" selected>All</option>
                        <option
                          v-for="stage in filterStages()"
                          :key="stage.id"
                          :value="stage.id"
                        >
                          {{ stage.name }}
                        </option>
                      </select>
                    </label>
                    <label class="width-full"
                      ><b>Planning status:</b>
                      <select v-model="status" class="form-control">
                        <option value="all" selected>All</option>
                        <option :value="true">Active</option>
                        <option :value="false">Inactive</option>
                      </select>
                    </label>
                    <input-button
                      type="button"
                      @click="resetFilters"
                      label="Reset filters"
                      class="btn-yellow mt-2"
                    />
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card no-body class="p-0">
                <b-card-header header-tag="header" class="p-0" role="tab">
                  <b-button block v-b-toggle.tab2 variant="light"
                    >Selected Items</b-button
                  >
                </b-card-header>
                <b-collapse id="tab2" visible role="tabpanel">
                  <b-card-body>
                    <b-card-text>
                      <p v-if="!selectedItems.length">No items selected.</p>
                      <ul>
                        <li
                          class="mb-2"
                          v-for="(selectedItem, index) in selectedItems"
                          :key="selectedItem.id"
                        >
                          {{ selectedItem.name }}
                          <b-button
                            v-b-tooltip.left="'Unselect item'"
                            class="
                              btn btn-danger btn-icon btn-circle btn-sm
                              pull-right
                            "
                            @click="unselect(index)"
                          >
                            <i class="fa fa-times" />
                          </b-button>
                        </li>
                      </ul>
                    </b-card-text>
                    <div v-if="selectedItems.length">
                      <label class="width-full"
                        ><b>Action:</b>
                        <select v-model="action" class="form-control">
                          <option value="view">View all</option>
                          <option value="delete">Delete</option>
                          <option
                            v-if="$route.params.level == 'stages'"
                            value="setStoryboard"
                          >
                            Add to storyboard
                          </option>
                          <option
                            v-if="$route.params.level == 'steps'"
                            value="setStage"
                          >
                            Add to stage
                          </option>
                        </select>
                      </label>
                      <b-button @click="selectAction" class="btn-yellow"
                        >Select</b-button
                      >
                      <input-button
                        type="button"
                        @click="unselectAll"
                        label="Unselect all"
                        class="btn-danger pull-right"
                      />
                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </b-card>
        </div>
      </div>
    </div>

    <div class="row m-t-10">
      <div class="col-6">
        <label
          ><b>Per page</b>
          <b-form-select v-model="perPage" :options="perPageOptions" />
        </label>
      </div>
      <b-pagination
        class="col-6 pagination"
        next-class="{ background-color: red; }"
        align="right"
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="itemTable"
      />
    </div>

    <div class="height-50">
      <hr />
      <url-button class="btn-secondary" label="Back" :url="'/storyboard'" />
      <url-button
        label="Create new"
        :url="createRoute"
        class="btn-yellow pull-right"
      />
    </div>

    <!-- begin delete modal -->
    <b-modal
      ref="modalAlert"
      centered
      :title="deleteModalTitle"
      cancel-variant="white"
      ok-variant="danger"
      ok-title="Delete"
      v-on:ok="deleteAction"
      scrollable
    >
      <div class="alert alert-danger m-b-0">
        <h5><i class="fa fa-info-circle mr-1" />Delete</h5>
        <p>{{ deleteModalQuery }}</p>
          <ul>
            <li v-for="selectedItem in selectedItems" :key="selectedItem.id">
              {{ selectedItem.name }}
            </li>
          </ul>
      </div>
    </b-modal>
    <!-- end delete modal -->
    <!-- begin add to parent modal -->
    <b-modal
      ref="modalAddToParent"
      centered
      :title="addToParentModalTitle"
      cancel-variant="white"
      ok-variant="yellow"
      ok-title="Add"
      v-on:ok="addToParentAction"
      scrollable
    >
      <template #modal-title>
        {{ addToParentModalTitle }}<br />
        <label class="width-full" v-if="$route.params.level == 'stages'">
          <select v-model="stageParent" class="form-control">
            <option :value="null" selected>None</option>
            <option v-for="sb in storyboards" :key="sb.id" :value="sb.id">
              {{ sb.name }}
            </option>
          </select>
        </label>
        <label class="width-full" v-if="$route.params.level == 'steps'">
          <select v-model="stepParent" class="form-control">
            <option :value="null" selected>None</option>
            <option v-for="stage in stages" :key="stage.id" :value="stage.id">
              {{ stage.name }}
            </option>
          </select>
        </label>      </template>

      <b>{{ addToParentModalSelected }}</b>
      <ul>
        <li v-for="selectedItem in selectedItems" :key="selectedItem.id">
          {{ selectedItem.name }}
        </li>
      </ul>
    </b-modal>
    <!-- end add to parent modal -->
    <!-- begin verify edit modal -->
    <b-modal
      ref="modalVerifyEdit"
      centered
      :title="addToParentModalTitle"
      cancel-variant="white"
    >
      <div class="alert alert-warning m-b-0">
        <h5><i class="fa fa-info-circle mr-1" />Verify selection</h5>
        <p>{{ verifyModalQuery }}</p>
        <b>{{ addToParentModalSelected }}</b>
        <vue-custom-scrollbar
          v-if="selectedItems.length > 15"
          class="height-sm"
        >
          <ul>
            <li
              v-for="selectedItem in selectedItems"
              :key="selectedItem.id"
              :class="hasParent(selectedItem) ? 'textUnderlined' : ''"
            >
              {{ selectedItem.name }}
            </li>
          </ul>
        </vue-custom-scrollbar>
        <div v-else>
          <ul>
            <li
              v-for="selectedItem in selectedItems"
              :key="selectedItem.id"
              :class="hasParent(selectedItem) ? 'textUnderlined' : ''"
            >
              {{ selectedItem.name }}
            </li>
          </ul>
        </div>
      </div>
      <template #modal-footer>
        <b-button variant="white" @click="$refs['modalVerifyEdit'].hide()"
          >Cancel</b-button
        >
        <b-button
          variant="dark"
          @click="bulkEditParent($route.params.level, true)"
        >
          {{ verifyEditParentlessButtonLabel }}
        </b-button>
        <b-button variant="yellow" @click="bulkEditParent($route.params.level)">
          {{ verifyEditButtonLabel }}
        </b-button>
      </template>
    </b-modal>
    <!-- end verify edit modal -->
    <!-- begin view modal -->
    <b-modal
      ref="modalViewAll"
      size="xl"
      centered
      title="Selected items"
      class="row"
      hide-footer
      @hidden="index = 0"
    >
      <div class="col-12" v-if="currentItem">
        <step-show
          :step="currentItem"
          :stage="getStage(currentItem.stage)"
          :storyboard="getStoryboard(currentItem)"
          :scriptItems="scriptItems"
          :modalMode="true"
          v-if="$route.params.level == 'steps'"
        />
        <stage-show
          :stage="currentItem"
          :steps="steps"
          :storyboard="getStoryboard(currentItem)"
          :scriptItems="scriptItems"
          :modalMode="true"
          v-if="$route.params.level == 'stages'"
        />
        <storyboard-show
          :storyboard="currentItem"
          :stages="stages"
          :scriptItems="scriptItems"
          :modalMode="true"
          v-if="$route.params.level == 'storyboards'"
        />
        <b-card
          bg-variant="dark"
          text-variant="light"
          v-if="selectedItems.length > 1"
        >
          <b-row>
            <b-col>
              <button
                @click="previousItem"
                class="btn btn-yellow btn-icon btn-circle btn-lg"
              >
                <i class="fa fa-chevron-left" />
              </button>
            </b-col>
            <b-col class="text-center">
              <!--<b-list-group horizontal>
                                <b-list-group-item class="text-center" button @click="toItem(index)" v-for="(selectedItem, index) in selectedItems" :key="selectedItem.id">{{ selectedItem.name }}</b-list-group-item>
                            </b-list-group>-->
              <h2>{{ index + 1 }} / {{ selectedItems.length }}</h2>
            </b-col>
            <b-col>
              <button
                @click="nextItem"
                class="btn btn-yellow btn-icon btn-circle btn-lg pull-right"
              >
                <i class="fa fa-chevron-right" />
              </button>
            </b-col>
          </b-row>
        </b-card>
      </div>
    </b-modal>
    <!-- end view modal -->
  </div>
</template>

<script>
import UrlButton from '../buttons/UrlButton.vue'
import InputButton from '../buttons/InputButton.vue'
import StepShow from '../storyboard/StepShow.vue'
import StageShow from '../storyboard/StageShow.vue'
import StoryboardShow from '../storyboard/StoryboardShow.vue'

export default {
  name: 'SearchTable',
  props: [
    'storyboards',
    'stages',
    'steps',
    'scriptItems',
    'removeImage',
    'removeFile',
    'deleteNoteCall',
    'bulkDeleteStoryboards',
    'bulkDeleteStages',
    'bulkDeleteSteps',
    'bulkSetStageStoryboards',
    'bulkSetStepStages'
  ],
  components: {
    UrlButton,
    InputButton,
    StepShow,
    StageShow,
    StoryboardShow
  },
  data() {
    return {
      itemsCheck: false,
      selectedItems: [],
      currentItem: null,
      search: '',
      storyboardFilter: 'all',
      stageFilter: 'all',
      status: 'all',
      perPageOptions: [5, 10, 25, 50, 100],
      perPage: 10,
      currentPage: 1,
      fields: [],
      action: 'view',
      index: 0,
      deleteModalTitle: '',
      deleteModalQuery: '',
      addToParentModalTitle: '',
      addToParentModalSelected: '',
      verifyEditButtonLabel: '',
      verifyEditParentlessButtonLabel: '',
      verifyModalQuery: '',
      stageParent: null,
      stepParent: null
    }
  },
  computed: {
    rows() {
      return this.itemsInType().length
    },
    createRoute() {
      let level = this.$route.params.level
      switch (level) {
        case 'storyboards':
          return '/storyboard/new'
        case 'stages':
          return '/storyboard/stage/new'
        case 'steps':
          return '/storyboard/step/new'
        default:
          return ''
      }
    },
    storyboardsWithCalculatedValues() {
      let storyboards = JSON.parse(JSON.stringify(this.storyboards))
      storyboards = storyboards.map((storyboard) => {
        const stages = this.stages.filter((stage) => {
          return stage.storyboard == storyboard.id
        })
        storyboard.stages = stages.length
        storyboard.steps = stages.map((stage) => stage.steps).flat().length
        return storyboard
      })
      return storyboards
    },
    stagesWithCalculatedValues() {
      let stages = JSON.parse(JSON.stringify(this.stages))
      stages = stages.map((stage) => {
        stage.stepCount = stage.steps.length
        return stage
      })
      return stages
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  methods: {
    setFields() {
      let level = this.$route.params.level
      switch (level) {
        case 'storyboards':
          this.fields = [
            { key: 'selected', sortable: false },
            { key: 'image', sortable: false },
            { key: 'name', sortable: true },
            { key: 'stages', sortable: true },
            { key: 'steps', sortable: true },
            { key: 'inUse', sortable: false },
            { key: 'actions', sortable: false }
          ]
          break
        case 'stages':
          this.fields = [
            { key: 'selected', sortable: false },
            { key: 'image', sortable: false },
            { key: 'name', sortable: true },
            { key: 'storyboard', sortable: true },
            { key: 'stepCount', sortable: true },
            { key: 'inUse', sortable: false },
            { key: 'actions', sortable: false }
          ]
          break
        case 'steps':
          this.fields = [
            { key: 'selected', sortable: false },
            { key: 'image', sortable: false },
            { key: 'name', sortable: true },
            { key: 'storyboard', sortable: true },
            { key: 'stage', sortable: true },
            { key: 'inUse', sortable: false },
            { key: 'actions', sortable: false }
          ]
          break
        default:
          break
      }
    },
    getImage(image) {
      if (image == null) {
        return require('../../assets/images/no_image.jpg')
      } else {
        return process.env.VUE_APP_API_URL + '/uploads/images/' + image.imageFd
      }
    },
    itemsInType() {
      let self = this
      let level = this.$route.params.level
      let items
      switch (level) {
        case 'storyboards':
          items = this.storyboardsWithCalculatedValues
          break
        case 'stages':
          items = this.stagesWithCalculatedValues
          break
        case 'steps':
          items = this.steps
          break
        default:
          items = this.storyboardsWithCalculatedValues
          break
      }

      return items.filter(function (item) {
        let stepStage = null
        if (item.stage && self.storyboardFilter != 'all') {
          stepStage = self.getStage(item.stage)
        }
        if (
          (item.storyboard && item.storyboard == self.storyboardFilter) ||
          self.storyboardFilter == 'all' ||
          (item.stage &&
            stepStage &&
            stepStage.storyboard == self.storyboardFilter)
        ) {
          if (
            (item.stage && item.stage == self.stageFilter) ||
            self.stageFilter == 'all'
          ) {
            if (
              (!self.status && self.checkUsage(item) == self.status) ||
              (self.status && self.checkUsage(item) == self.status) ||
              self.status == 'all'
            ) {
              if (self.search) {
                if (
                  item.name.toLowerCase().includes(self.search.toLowerCase())
                ) {
                  return item
                }
              } else {
                return item
              }
            }
          }
        }
      })
    },
    getItemSteps(item) {
      let level = this.$route.params.level
      let storyboardStages = []
      let stageStepIds = []
      switch (level) {
        case 'storyboards':
          storyboardStages = this.stages.filter((stage) => {
            return stage.storyboard == item.id
          })
          storyboardStages.forEach((stage) => {
            stage.steps.forEach((step) => {
              stageStepIds.push(step.id)
            })
          })
          return stageStepIds
        case 'stages':
          return item.steps
        default:
          break
      }
    },
    getStoryboard(item) {
      let level = this.$route.params.level
      let storyboardId = null
      switch (level) {
        case 'stages':
          storyboardId = item.storyboard
          break
        case 'steps':
          storyboardId = item.stage
            ? this.getStage(item.stage).storyboard
            : null
          break
        default:
          break
      }
      let fullStoryboard = null
      if (storyboardId) {
        this.storyboards.forEach((sb) => {
          if (sb.id == storyboardId) {
            fullStoryboard = sb
          }
        })
        return fullStoryboard
      } else {
        return null
      }
    },
    getStage(stageId) {
      let fullStage = null
      this.stages.forEach((stage) => {
        if (stage.id == stageId) {
          fullStage = stage
        }
      })
      return fullStage
    },
    resetFilters() {
      this.search = ''
      this.storyboardFilter = 'all'
      this.stageFilter = 'all'
      this.status = 'all'
      this.action = 'view'
    },
    filterStages() {
      var fStages = []
      this.stages.forEach((stage) => {
        if (!fStages.includes(stage) && stage.steps.length) {
          if (this.storyboardFilter == 'all') {
            fStages.push(stage)
          } else {
            if (stage.storyboard == this.storyboardFilter) {
              fStages.push(stage)
            }
          }
        }
      })
      return fStages
    },
    checkUsage(item) {
      let level = this.$route.params.level
      let status = false
      let storyboardStages = []
      let stageStepIds = []
      switch (level) {
        case 'storyboards':
          storyboardStages = this.stages.filter((stage) => {
            return stage.storyboard == item.id
          })
          storyboardStages.forEach((stage) => {
            stage.steps.forEach((step) => {
              stageStepIds.push(step.id)
            })
          })
          this.scriptItems.forEach((scriptItem) => {
            if (stageStepIds.includes(scriptItem.step.id)) {
              status = true
            }
          })
          return status
        case 'stages':
          item.steps.forEach((step) => {
            stageStepIds.push(step.id)
          })
          this.scriptItems.forEach((scriptItem) => {
            if (stageStepIds.includes(scriptItem.step.id)) {
              status = true
            }
          })
          return status
        case 'steps':
          this.scriptItems.forEach((scriptItem) => {
            if (item.id == scriptItem.step.id) {
              status = true
            }
          })
          return status
        default:
          return status
      }
    },
    viewRoute(item) {
      let level = this.$route.params.level
      switch (level) {
        case 'storyboards':
          return `/storyboard/${item.id}`
        case 'stages':
          return `/storyboard/${item.storyboard}/stage/${item.id}`
        case 'steps':
          return `/storyboard/${
            item.stage && this.getStoryboard(item)
              ? this.getStoryboard(item).id
              : null
          }/stage/${item.stage}/step/${item.id}`
        default:
          return ''
      }
    },
    planRoute(item) {
      let level = this.$route.params.level
      switch (level) {
        case 'storyboards':
          return `/storyboard/${item.id}/plan`
        case 'stages':
          return `/storyboard/${item.storyboard}/stage/${item.id}/plan`
        default:
          return ''
      }
    },
    planTitle() {
      let level = this.$route.params.level
      switch (level) {
        case 'storyboards':
          return 'Set Stages & Steps'
        case 'stages':
          return 'Set Steps'
        default:
          return ''
      }
    },
    itemCheck(checked) {
      if (!checked) {
        this.itemsCheck = false
      }
    },
    checkAll(checked) {
      if (checked) {
        let itemsInType = this.itemsInType()
        itemsInType.forEach((itemInType) => {
          if (
            !this.selectedItems.find(
              (selectedItem) => selectedItem.id == itemInType.id
            )
          ) {
            this.selectedItems.push(itemInType)
          }
        })
      } else {
        let itemsInType = this.itemsInType()
        itemsInType.forEach((itemInType) => {
          let index = this.selectedItems.findIndex(
            (selectedItem) => selectedItem.id == itemInType.id
          )
          if (index != -1) {
            this.selectedItems.splice(index, 1)
          }
        })
      }
    },
    unselect(index) {
      this.itemsCheck = false
      this.selectedItems.splice(index, 1)
    },
    unselectAll() {
      this.selectedItems = []
      this.itemsCheck = false
      this.currentItem = null
    },
    setSelected() {
      if (this.selectedSteps && this.selectedSteps.length) {
        this.selectedItems = this.selectedSteps
        if (
          this.selectedItems.length ==
          this.itemsInType(this.activeEvent.id).length
        ) {
          this.itemsCheck = true
        }
      }
    },
    selectAction() {
      switch (this.action) {
        case 'view':
          this.currentItem = this.selectedItems[0]
          this.$refs['modalViewAll'].show()
          this.showItemById(this.selectedItems[0].id)
          break
        case 'delete':
          this.$refs['modalAlert'].show()
          break
        case 'setStoryboard':
          this.$refs['modalAddToParent'].show()
          break
        case 'setStage':
          this.$refs['modalAddToParent'].show()
          break
        default:
          break
      }
    },
    previousItem() {
      if (this.index == 0) {
        this.index = this.selectedItems.length - 1
      } else {
        this.index--
      }
      this.showItemById(this.selectedItems[this.index].id)
    },
    nextItem() {
      if (this.index == this.selectedItems.length - 1) {
        this.index = 0
      } else {
        this.index++
      }
      this.showItemById(this.selectedItems[this.index].id)
    },
    /*toItem(index) {
            this.showItemById(this.selectedItems[index].id);
            this.index = index;
        },*/
    showItemById(itemId) {
      this.selectedItems.forEach((selectedItem) => {
        if (selectedItem.id == itemId) {
          this.currentItem = selectedItem
        }
      })
    },
    setModalLabels() {
      let level = this.$route.params.level
      switch (level) {
        case 'storyboards':
          this.deleteModalTitle = 'Delete selected storyboards'
          this.deleteModalQuery =
            'Are you sure you want to delete these storyboards?'
          break
        case 'stages':
          this.deleteModalTitle = 'Delete selected stages'
          this.deleteModalQuery =
            'Are you sure you want to delete these stages?'
          this.addToParentModalTitle = 'Add selected stages to a storyboard'
          this.addToParentModalSelected = 'Selected stages:'
          this.verifyEditButtonLabel = 'Add all'
          this.verifyEditParentlessButtonLabel = 'Add only storyboardless'
          this.verifyModalQuery =
            'Underlined stages already have a storyboard. Add all anyways or add only storyboardless stages?'
          break
        case 'steps':
          this.deleteModalTitle = 'Delete selected steps'
          this.deleteModalQuery = 'Are you sure you want to delete these steps?'
          this.addToParentModalTitle = 'Add selected steps to a stage'
          this.addToParentModalSelected = 'Selected steps:'
          this.verifyEditButtonLabel = 'Add all'
          this.verifyEditParentlessButtonLabel = 'Add only stageless'
          this.verifyModalQuery =
            'Underlined steps already have a stage. Add all anyways or add only stageless steps?'
          break
        default:
          break
      }
    },
    deleteAction() {
      let level = this.$route.params.level
      this.bulkDelete(level)
    },
    bulkDelete(level) {
      this.selectedItems.forEach((selectedItem) => {
        if (selectedItem.image) {
          this.removeImage(selectedItem.image.id)
        }
        selectedItem.files.forEach((file) => {
          this.removeFile(file.id)
        })
        selectedItem.notes.forEach((note) => {
          this.deleteNoteCall(note.id)
        })
        switch (level) {
          case 'storyboards':
            this.bulkDeleteStoryboards(selectedItem.id)
            break
          case 'stages':
            this.bulkDeleteStages(selectedItem.id)
            break
          case 'steps':
            this.bulkDeleteSteps(selectedItem.id)
            break
          default:
            break
        }
      })
      this.unselectAll()
    },
    addToParentAction() {
      let level = this.$route.params.level
      //this.bulkEditParent(level);
      this.verifySelection(level)
    },
    verifySelection(level) {
      let itemsHaveParent = false
      switch (level) {
        case 'stages':
          this.selectedItems.forEach((selectedItem) => {
            if (selectedItem.storyboard) {
              itemsHaveParent = true
            }
          })
          if (itemsHaveParent) {
            this.$refs['modalVerifyEdit'].show()
          } else {
            this.bulkEditParent(level)
          }
          break
        case 'steps':
          this.selectedItems.forEach((selectedItem) => {
            if (selectedItem.stage) {
              itemsHaveParent = true
            }
          })
          if (itemsHaveParent) {
            this.$refs['modalVerifyEdit'].show()
          } else {
            this.bulkEditParent(level)
          }
          break
        default:
          break
      }
    },
    hasParent(item) {
      let level = this.$route.params.level
      switch (level) {
        case 'stages':
          return item.storyboard ? true : false
        case 'steps':
          return item.stage ? true : false
        default:
          return false
      }
    },
    bulkEditParent(level, onlyParentless = false) {
      this.selectedItems.forEach((selectedItem) => {
        switch (level) {
          case 'stages':
            if (onlyParentless) {
              if (!selectedItem.storyboard) {
                this.bulkSetStageStoryboards(
                  selectedItem.id,
                  JSON.stringify({
                    storyboard: this.stageParent
                  })
                )
              }
            } else {
              this.bulkSetStageStoryboards(
                selectedItem.id,
                JSON.stringify({
                  storyboard: this.stageParent
                })
              )
            }
            break
          case 'steps':
            if (onlyParentless) {
              if (!selectedItem.stage) {
                this.bulkSetStepStages(
                  selectedItem.id,
                  JSON.stringify({
                    stage: this.stepParent
                  })
                )
              }
            } else {
              this.bulkSetStepStages(
                selectedItem.id,
                JSON.stringify({
                  stage: this.stepParent
                })
              )
            }
            break
          default:
            break
        }
      })
      this.$refs['modalVerifyEdit'].hide()
      this.unselectAll()
    }
  },
  mounted() {
    this.setFields()
    this.setModalLabels()
  },
  watch: {
    $route() {
      this.resetFilters()
      this.setFields()
      this.unselectAll()
      this.setModalLabels()
    }
  }
}
</script>
